<template>
	<div id="ghost">
		<div  class="ghost">
			<div class="ghost__waves">
				<div class="ghost__wave"></div>
				<div class="ghost__wave"></div>
			</div>
			<div class="ghost__eyes">
				<div class="ghost__eyes_eye"></div>
				<div class="ghost__eyes_eye"></div>
			</div>
			<div class="ghost__mouth"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ghost",
	methods: {
		ghost() {
			const ghost = document.getElementById('ghost');
			ghost.classList.remove('active'); // на всякий случай
			let ghostX = 0;
			let ghostY = 0;

			// базові розміри макета
			const BASE_W = 117;
			const BASE_H = 150;
			const TARGET_H = 26; // бажана висота ~26 px
			const BASE_SCALE = TARGET_H / BASE_H; // ~0.1733

			function countShift(value, inMin, inMax, outMin, outMax) {
				const numerator = (value - inMin) * (outMax - outMin);
				const denominator = (inMax - inMin);
				return (numerator / denominator) + outMin;
			}

			function followCursor(pageX, pageY) {
				// центримо по курсору: віднімаємо пів розміру з урахуванням масштабу
				const targetX = (pageX) - ((BASE_W * BASE_SCALE) / 2);
				const targetY = (pageY) - ((BASE_H * BASE_SCALE) / 2);

				const diffX = targetX - ghostX;
				const diffY = targetY - ghostY;

				const skewX = diffX / 16;
				const scaleDelta = diffY / 16;

				ghostX += diffX / 8; // інерція
				ghostY += diffY / 8;

				const skewDegrees = countShift(skewX, 0, 50, 0, -25);
				// легкий “подих”, щоб не міняти фактичний розмір сильно
				const scaleYValue = countShift(scaleDelta, 0, 50, 0.9, 1.1);

				ghost.style.transform =
						`translate(${ ghostX }px, ${ ghostY }px) skew(${ skewDegrees }deg) rotate(${ -skewDegrees }deg) ` +
						`scale(${ BASE_SCALE }) scaleY(${ scaleYValue })`;
			}

			const handleMouseMove = (e) => {
				ghost.classList.add('active');

				// працюємо у координатах в’юпорту, щоб не було зсувів при скролі
				const x = ('clientX' in e) ? e.clientX : e.pageX;
				const y = ('clientY' in e) ? e.clientY : e.pageY;

				followCursor(x, y);
			};

			document.addEventListener('mousemove', handleMouseMove);
			document.addEventListener('mouseleave', () => {
				ghost.classList.remove('active');
				ghost.style.animation = 'none';
			});
			
			document.addEventListener('mousemove', () => {
				ghost.classList.add('active'); // при первом движении — показ
				// followCursor(...)
			});

			document.addEventListener('mouseleave', () => {
				ghost.classList.remove('active'); // снова прозрачный
				ghost.style.animation = 'none';
			});
		}

	},
	mounted() {
		this.ghost();
	},
};
</script>

<style scoped lang="scss">

#ghost {
	position: fixed;       // не залежить від верстки
	left: 0;
	top: 0;
	z-index: 9999;
	pointer-events: none;  // щоб не заважав клікам
	transform-origin: center;

	/* <- новое */
	opacity: 0;                     /* полностью прозрачен изначально */
	transition: opacity .25s ease;  /* плавное появление */
}

#ghost.active {
	opacity: 1;                     /* показываем при движении мыши */
}

.ghost {
	background: #fff;
	width: 117px;
	height: 150px;
	border-radius: 100px 100px 0 0;
	box-shadow: 0 0 50px #fff;
	position: relative;
	transform-origin: center;
	animation: float 3s ease-out infinite;
}

.ghost__eyes {
	display: flex;
	gap: 25px;
	padding-top: 44px;
	justify-content: center;
	position: relative;
}

.ghost__eyes_eye {
	width: 10px;
	height: 16px;
	background: #fff;
	border: 4px solid #ccc;
	border-radius: 100px;
	clip-path: polygon(100% 50%, 100% 100%, 0 100%, 0 50%);
	transition: .1s;
}

.ghost__mouth {
	width: 44px;
	height: 8px;
	background: #ccc;
	border-radius: 10px;
	margin: 16px auto 0;
	position: relative;
	animation: sleep 3s ease-out infinite;
	transition: .1s;
}

.ghost__mouth:before {
	content: "";
	position: absolute;
	left: 5px;
	top: 0;
	width: 8px;
	height: 14px;
	background: #ccc;
	border-radius: 10px;
	animation: drool 3s ease-out infinite;
}

.ghost__waves {
	display: flex;
	position: absolute;
	bottom: -20px;
	height: 50px;
	width: 100%;
	overflow: hidden;
}

.ghost__wave {
	width: 117px;
	height: 50px;
	background: #fff;
	flex-shrink: 0;

	animation: ghost 3s linear infinite;
	transform: translateX(-117px);

	--size: 10px;
	--p: 5px;
	--R: 11.18px;

	-webkit-mask:
			radial-gradient(var(--R) at 50% calc(100% - (var(--size) + var(--p))),blue 99%,#0000 101%) calc(50% - 2*var(--size)) 0/calc(4*var(--size)) 100%,
			radial-gradient(var(--R) at 50% calc(100% + var(--p)),#0000 99%,red 101%) 50% calc(100% - var(--size))/calc(4*var(--size)) 100% repeat-x;
}

@keyframes ghost {
	0% {
		transform: translateX(-117px);
	}
	100%{
		transform: translateX(0);
	}
}

@keyframes sleep {
	0% {
		width: 44px;
	}
	50% {
		width: 26px;
	}
	100%{
		width: 44px;
	}
}

@keyframes drool {
	0% {
		height: 14px;
	}
	50% {
		height: 20px;
	}
	100%{
		height: 14px;
	}
}

@keyframes float {
	50% {
		transform: translate(0, 20px);
	}
}

.ghost:hover .ghost__eyes_eye,
#ghost.active .ghost__eyes_eye {
	background: #000;
	border-color: #000;
	clip-path: none;
	height: 16px;
}

.ghost:hover .ghost__mouth:before,
#ghost.active .ghost__mouth:before {
	display: none;
}

.ghost:hover .ghost__mouth,
#ghost.active .ghost__mouth {
	animation: none;
	background: #000;
	width: 32px;
	height: 29px;
	clip-path: polygon(100% 50%, 100% 100%, 0 100%, 0 50%);
	border-radius: 100px;
	margin-top: 1px;
}

#ghost.active .ghost {
	animation: none;
}
</style>
